import { CheckoutRequest, Entity } from 'common/interface';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface CheckoutFrameState {
  checkoutRequest?: CheckoutRequest;
  entity?: Entity;
  setCheckoutRequest: (checkoutRequest: CheckoutRequest) => void;
  setEntity: (entity: Entity) => void;
}

export const useCheckoutFrameStore = create<CheckoutFrameState>()(
  devtools((set) => ({
    setCheckoutRequest: (checkoutRequest: CheckoutRequest) => set({ checkoutRequest }),
    setEntity: (entity: Entity) => set({ entity }),
  })),
);
